import React, { useEffect, useState } from "react";

import "./style.scss"
import { BsPlus } from "react-icons/bs";
import CustomTable from "../../../assets/component/table";

const tableHeaderData = [
    {
        title: "Team Name",
        key: "teamname",
        dataIndex: "teamname",
        sorter: {
            compare: (a, b) => a.teamname.localeCompare(b.teamname),
        }
    },
    {
        title: "Count of Users",
        key: "count",
        dataIndex: "count",
        sorter: {
            compare: (a, b) => a.count.localeCompare(b.count),
        }
    },
    {
        title: "Action",
        key: "action",
        dataIndex: "action",
        render: () => {
            return (
                <div>Manage Team</div>
            )
        }
    },

]

const tableData = [
    { key: "ESG001", teamname: 'Team 1', count: "4" },
    { key: "ESG002", teamname: 'Team 2', count: "7" },
    { key: "ESG003", teamname: 'Team 3', count: "3" },
]

const TeamSection = () => {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(50);
    const [loading, setLoading] = useState(false);
    const [formattedTableData, setFormattedTableData] = useState({
        dataSource: [],
        columns: []
    });

    const setData = () => {
        setFormattedTableData({ dataSource: [...tableData], columns: [...tableHeaderData] });
    }

    useEffect(() => {
        setData();
    }, [])

    return (
        <div className="team-details-section">
            <div className="wrapper">
                <div className="title-section">Teams</div>
                <div className="btn add-btn"><BsPlus /> Add Team</div>
            </div>
            <div className="source-list-table-section">
                <CustomTable
                    page={page}
                    limit={limit}
                    setPage={setPage}
                    setLimit={setLimit}
                    tableData={formattedTableData}
                    isLoading={loading}
                />
            </div>
        </div>
    )
}

export default TeamSection;